import type { Customer } from '@/api/customers'
import { countryName } from '@/lib/countries'

/**
 * "Mühlenweg 12, 33602 Bielefeld, Deutschland" — the parts that are there, in reading order.
 *
 * The country is stored as an ISO code and read out as a name: "DE" in a line of an address reads
 * as a typo, and the name is what somebody scanning a list recognises. A code the browser cannot
 * name — one left over from before the codes — is shown as it stands rather than dropped.
 *
 * Null rather than an empty string when nothing is set, so a caller can decide what to show
 * instead; a customer entered at a stand often has a name and nothing else.
 */
export function formatAddress(customer: Customer, language: string): string | null {
  const { street, postalCode, city, country } = customer.address
  const town = [postalCode, city].filter(Boolean).join(' ')
  return [street, town, country && countryName(country, language)].filter(Boolean).join(', ') || null
}
